// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2maiC","colMin":"styles_colMin__30RwU"};